import React, { useState } from 'react';
import { InfoComponent } from '../infoComponent';
import './infoModal.css';

export default function QuestionMark({ infoSection, disabled, style, title }) {
    const [isInfoOpen, setIsInfoOpen] = useState(false);

    return (
        <>
            <button
                title={title}
                className="question-mark-button"
                onClick={() => setIsInfoOpen(true)}
                disabled={disabled}
                style={style}
            >
                ?
            </button>
            <InfoComponent
                isOpen={isInfoOpen}
                onClose={() => setIsInfoOpen(false)}
                activeSection={infoSection}
            />
        </>
    );
}